module.exports = __webpack_public_path__ + "static/media/Speech bubble (right adjusted).5b2ffad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wordMark2/Speech bubble (right adjusted).png
// module id = 862
// module chunks = 0